import React from "react";
import Priority from "./Priority";
import Effort from "./Effort";
import MoveToProjectComponent from './MoveToProjectComponent';
import AreaType from "./AreaType";
import Toast from 'react-bootstrap/Toast';
import moment from 'moment';
import Select from 'react-select';
import CategorySuggestion from "./MLSuggestions"
import {authFetch,handleResponse} from './utils'
import {getCategoryIcon} from './categoryIcons';
import { baseURL } from "./utils";
import TaskActionsSection from "./TaskActionsSection";

import Form from 'react-bootstrap/Form';
class TaskDetailsComponent extends React.Component {
	constructor(props) {
		super(props);
		this.handleTaskNameChange = this.handleTaskNameChange.bind(this);
		this.onAutoReminderEndTimeChange = this.onAutoReminderEndTimeChange.bind(this);

		
		this.handleTaskTypeChange = this.handleTaskTypeChange.bind(this);
		this.onProjectChange = this.onProjectChange.bind(this);
		this.onReminderTimeChange = this.onReminderTimeChange.bind(this);
		this.onAreaTypeChange = this.onAreaTypeChange.bind(this);
		this.handeMarkAsCompleted = this.handeMarkAsCompleted.bind(this);
		this.onItemAdded = this.onItemAdded.bind(this);
		this.addReminder = this.addReminder.bind(this);
		this.onPriorityChange = this.onPriorityChange.bind(this);
		this.onEffortChange = this.onEffortChange.bind(this);
		this.handeMarkAsCompletedButton = this.handeMarkAsCompletedButton.bind(this);
		this.handleCompletedDateChange = this.handleCompletedDateChange.bind(this);
		this.discard = this.discard.bind(this);
		this.doSave = this.doSave.bind(this);
		this.reschedule = this.reschedule.bind(this);
		this.onCategoryChange = this.onCategoryChange.bind(this);
		this.isRecurringTask = this.isRecurringTask.bind(this);
		this.onReminderTypeChange = this.onReminderTypeChange.bind(this);

		
		this.handleActualEffortInMinsChange = this.handleActualEffortInMinsChange.bind(this);
		var mappedCategories = [];
		if(this.props.currentItem.categories){
			mappedCategories = this.props.currentItem.categories.map(category=>{
				return {"name":category.name,"id":category.id}
			});
		}
		this.state = {
			
			taskName: this.props.currentItem.taskDetails.name,
			taskType: this.props.currentItem.taskType,
			currentArea: this.props.currentItem.taskDetails.area,
			completedDate: this.props.currentItem.taskDetails.completedDate,
			completedFlag: false,
			currentEffort: this.props.currentItem.taskDetails.effort,
			currentPriority: this.props.currentItem.taskDetails.priority,
			actualEffortInMins: this.props.currentItem.taskDetails.actualEffortInMins,
			reminderType: "FIXED",
			reminderEndTime:null,
			currentProject: '',
			show: false,
			saving: false,
			discarding: false,
			markingAsComplete: false,
			selectedCategories:mappedCategories

		}
		this.state.timeconstraint={minutes:{step: 15}}
		if (this.props.currentItem.taskDetails.completedDate != null)
			this.state.completedFlag = true;
		if (this.props.currentItem.taskDetails.reminder != null){
			this.state.reminderTime = this.props.currentItem.taskDetails.reminder.timeString;
			if(this.props.currentItem.taskDetails.reminder.auto){
				this.state.reminderType = "AUTO";
				this.state.reminderEndTime = this.props.currentItem.taskDetails.reminder.endDate;
			} else if(this.props.currentItem.taskDetails.reminder.cronexpr){
				this.state.reminderType = "CRON";
			}

		}
		if (this.props.currentItem.taskDetails.project != null) {
			this.state.currentProject = this.props.currentItem.taskDetails.project.name;

		}


	}
	isRecurringTask(){
		return this.props.currentItem.taskDetails.reminder != null && this.props.currentItem.taskDetails.reminder.cronexpr
	}
	
	onCategoryChange(category) {
		var result = category ? [{"name": category.label, "id": category.value}] : [];
		this.setState({selectedCategories: result});
	}
	onReminderTypeChange(event) {
		if (event.target.name === "AUTO") {
			this.setState({ "reminderType": event.target.name, "reminderTime": null })
		} else
			this.setState({ reminderType: event.target.name })

	}
	onItemAdded(event) {
		this.setState({ completedDate: this.state.completedDate ? this.state.completedDate : new Date(), completedFlag: true }, () => this.doSave());
		// this.props.onItemChanged(event);
	}
	handleActualEffortInMinsChange(event) {
		this.setState({ actualEffortInMins: event.target.value })
	}
	handleTaskNameChange(event) {
		this.setState({ taskName: event.target.value });
	}
	handleCompletedDateChange(event) {
		this.setState({ completedDate: event.toDate(), completedFlag: true });
	}

	discard(event) {
		event.preventDefault();
		this.setState({"discarding":true})
		authFetch(baseURL+'/v1/task/' + this.props.currentItem.taskDetails.id + "/discard", {
			method: 'PATCH',
		}).then(res => handleResponse(res))
			.then(
				(result) => {
					this.setState({ show: true,"discarding":false });
					this.props.onItemChanged();
				});
	}

	onProjectChange(event) {
		this.setState({ currentProject: event });
		for (var i = 0; i < this.props.projects.length; i++) {
			var project = this.props.projects[i];
			var projectName = project.name;
			if (projectName && projectName === event && project.area) {
				this.setState({ currentArea: project.area });
				break;
			}
		}
	}
	onReminderTimeChange(event) {
		if (event.target !== undefined)
			this.setState({ reminderTime: event.target.value });
		else
			this.setState({ reminderTime: event });
	}
	reschedule() {
		if (this.state.reminderType === 'FIXED' && this.state.reminderTime) {
			this.doSave();
		} else {
			this.setState({ reminderTime: null }, () => this.doSave());
		}
	}
	onAutoReminderEndTimeChange(event) {
		if (event !== undefined)
			this.setState({ reminderEndTime: event });
		else
			this.setState({ reminderEndTime: event });
	}
	compareTime(stateReminder, propsReminder) {
		var propsReminderTime;
		if (propsReminder != null)
			propsReminderTime = propsReminder.timeString;
		if (stateReminder === propsReminderTime)
			return true;
		else
			return false;

	}
	addReminder() {
		return;
		/*if(this.compareTime(this.state.reminderTime,this.props.currentItem.taskDetails.reminder)){
			return;
		}
		//return;
		var summary=this.props.currentItem.taskDetails.name;
		var time =new Date(this.state.reminderTime);
		var event = {
	'summary': summary,
  
	'start': {
	'dateTime': time,
	'timeZone': 'Asia/Qatar'
	},
	'end': {
	'dateTime': time,
	'timeZone': 'Asia/Qatar'
	},
  
	'reminders': {
	'useDefault': false,
	'overrides': [
	  
		{'method': 'popup', 'minutes': 10}
	]
	}
};
var gapi={};
		var request = gapi.client.calendar.events.insert({
				'calendarId': 'primary',
				'resource': event
			});
			request.execute(function(event) {
				console('Event created: ' + event.htmlLink);
			});
		*/
	}

	onAreaTypeChange(event) {
		this.setState({ currentArea: event });
	}
	onEffortChange(event) {
		this.setState({ currentEffort: event });
	}
	onPriorityChange(event) {
		this.setState({ currentPriority: event });
	}
	handeMarkAsCompleted(event) {
		if (event.target.checked) {
			this.setState({ completedDate: new Date(), completedFlag: true })
		} else {
			this.setState({ completedDate: null, completedFlag: false })
		}
	}
	handeMarkAsCompletedButton(event) {
		event.preventDefault();
		this.setState({"markingAsComplete":true})
		if (this.props.reminder != null && this.props.reminder.cronexpr) {

			var textData = this.state.taskName;
			if (textData.length === 0)
				return;
				
			authFetch(baseURL+'/v1/task/add', {
				method: 'POST',
				body: JSON.stringify({
					name: textData,
					completedFlag: true
				}
				)
			}).then(res => handleResponse(res))
				.then(
					(result) => {

					});

		} else{
			this.setState({ completedDate: this.state.completedDate?this.state.completedDate:new Date(), completedFlag: true }, () => this.doSave());
		}
			
			this.setState({"markingAsComplete":false})
	}


	handleTaskTypeChange(value) {
		this.setState({ taskType: value });
	}
	doSave() {
		this.addReminder();
		this.setState({"saving":true})
		var completedDate = null;
		
		//var mappedCategories = this.props.categories.filter(category=>this.state.selectedCategories.includes(category.value)).map(category=>{return {"name":category.label}});
		if (this.state.completedDate != null) {
			completedDate = moment(this.state.completedDate).format("DD-MMM-YYYY HH:mm")
		}
		
		authFetch(baseURL+'/v1/task/update', {
			method: 'POST',
			body: JSON.stringify({
				id: this.props.currentItem.taskDetails.id,
				previousTaskType: this.props.currentItem.taskType,
				currentTaskType: this.state.taskType,
				area: this.state.currentArea,
				name: this.state.taskName,
				categories:this.state.selectedCategories,
				completedDate,
				effort: this.state.currentEffort,
				priority: this.state.currentPriority,
				completedFlag: this.state.completedFlag,
				reminderTime: this.state.reminderTime,
				reminderEndTime: this.state.reminderEndTime,
				approxTimeInMinsToComplete: this.state.actualEffortInMins,
				projectName: this.state.currentProject,
				reminderType:this.state.reminderType

			})
		}).then(res => handleResponse(res))
			.then(
				(result) => {
					console.log(result);
					this.setState({ show: true });
					this.props.onItemChanged();
					this.setState({"saving":false})
				});

	}


	render() {
		var isRecurringTask = this.isRecurringTask();
		return <>
			{!isRecurringTask && this.props.showTopFields && <>
				<Form.Group className="mb-3">
					<Form.Label><i className="bi bi-card-text me-1"></i>Name</Form.Label>
					<Form.Control type="text" onChange={this.handleTaskNameChange} value={this.state.taskName} />
				</Form.Group>
				<Form.Group className="mb-3">
					<Form.Label><i className="bi bi-folder me-1"></i>Project</Form.Label>
					<MoveToProjectComponent projects={this.props.projects} onProjectChange={this.onProjectChange} currentItem={this.props.currentItem} items={this.props.allItems} />
				</Form.Group>
				<Form.Group className="mb-3">
					<Form.Label><i className="bi bi-person me-1"></i>Personal</Form.Label>
					<AreaType currentAreaType={this.state.currentArea} onAreaTypeChange={this.onAreaTypeChange} />
				</Form.Group>
				<Form.Group className="mb-3">
					<Form.Label><i className="bi bi-tag me-1"></i>Categories</Form.Label>
					<Select
						name="colors"
						onChange={this.onCategoryChange}
						options={this.props.categories}
						className="basic-single"
						value={this.props.categories.find(obj => this.state.selectedCategories.map(c => c.id).includes(obj.value)) || null}
						classNamePrefix="select"
						isClearable
						formatOptionLabel={opt => <span><i className={`bi ${getCategoryIcon(opt.label)} me-1`}></i>{opt.label}</span>}
					/>
					<CategorySuggestion onCategorySelect={this.onCategoryChange} categories={this.props.categories} selectedCategories={this.state.selectedCategories} currentItem={this.props.currentItem}/>
				</Form.Group>
				<Form.Group className="mb-3">
					<div className="d-flex gap-4 align-items-start">
						<Effort effort={this.state.currentEffort} onEffortChange={this.onEffortChange} />
						<div style={{ width: '1px', alignSelf: 'stretch', background: 'var(--bs-border-color)', margin: '0 4px' }} />
						<Priority priority={this.state.currentPriority} onPriorityChange={this.onPriorityChange} />
					</div>
				</Form.Group>
			</>}

			<TaskActionsSection
				activeSection={this.props.activeSection}
				showTopFields={this.props.showTopFields}
				isRecurringTask={isRecurringTask}
				currentItem={this.props.currentItem}
				contexturl={this.props.contexturl}
				reminderTime={this.state.reminderTime}
				reminderEndTime={this.state.reminderEndTime}
				reminderType={this.state.reminderType}
				completedDate={this.state.completedDate}
				actualEffortInMins={this.state.actualEffortInMins}
				selectedCategories={this.state.selectedCategories}
				taskName={this.state.taskName}
				currentEffort={this.state.currentEffort}
				currentPriority={this.state.currentPriority}
				currentArea={this.state.currentArea}
				timeconstraint={this.state.timeconstraint}
				onReminderTypeChange={this.onReminderTypeChange}
				onAutoReminderEndTimeChange={this.onAutoReminderEndTimeChange}
				onReminderTimeChange={this.onReminderTimeChange}
				handleCompletedDateChange={this.handleCompletedDateChange}
				handleActualEffortInMinsChange={this.handleActualEffortInMinsChange}
				onItemAdded={this.onItemAdded}
				handeMarkAsCompletedButton={this.handeMarkAsCompletedButton}
				doSave={this.doSave}
				reschedule={this.reschedule}
				discard={this.discard}
				markingAsComplete={this.state.markingAsComplete}
				saving={this.state.saving}
				discarding={this.state.discarding}
			/>

			<Toast bg="info" delay={4000} autohide show={this.state.show} onClose={() => this.setState({ show: false })}>
				<Toast.Header>
					<strong className="me-auto">Organizer</strong>
				</Toast.Header>
				<Toast.Body>Saved</Toast.Body>
			</Toast>
		</>
	}
	}

export default TaskDetailsComponent;
